module.exports = __webpack_public_path__ + "static/media/ehealth_minor_redemption_banner_desktop.9e317c8b.jpg";